export default __webpack_public_path__ + "static/media/040_tunnel.f470f190.mp4";